export const RESET_ERROR = 'dashboard/RESET_ERROR';

export const FETCH_LAST_USERS_SUCCESS = 'dashboard/FETCH_LAST_USERS_SUCCESS';
export const FETCH_LAST_USERS_FAIL = 'dashboard/FETCH_LAST_USERS_FAIL';
